module.exports = __webpack_public_path__ + "static/media/title.532ea8f1.png";